import React from 'react';
import './TarhDar.css';
import SimpleContext from './../../context/SimpleContext';
import { useContext } from 'react';
import TarhDarProduct from './TarhDarProduct';
import TarhDarDrawer from './../TarhDarDrawer/TarhDarDrawer';
import { Row } from 'react-bootstrap';
import { useHistory } from 'react-router';

const TarhDarProducts = () => {

    const context = useContext(SimpleContext);
    const history = useHistory();


    return ( 
        <div className="TaarhdarProductsPage">
            <div className="otherPagesHeader">
                <div className="otherPagesHeader">
                    <div className="barbuttonn">
                        {/* <img src="images/Api.jpg" className="apiLogoHeaders" alt=""/> */}
                    </div>
                    <div className="headersNames">
                        <p style={{margin:"0", fontSize:"11px"}}>پله های طرح  {context.TarhNameHeader}</p>
                    </div>
                    <div className="searchbtnn" onClick={()=>history.go(-1)}>
                        <i className="fa fa-chevron-left" />
                    </div>
                </div>
            </div>
           <div className="tarhhaPlace">
                {
                    context.FilteredTarhydar.length ? 
                    context.FilteredTarhydar.map(Disc =>                               
                        <div className="tarhha">
                            <TarhDarProduct 
                                images = {Disc.IMG}
                                title = {Disc.Title}
                                description = {Disc.description}
                                Percent = {Disc.DiscountPercent}
                                discountGroup = {Disc.DiscountGroup}
                                Az = {Disc.Az}
                                Ta = {Disc.Ta}
                            /> 
                        </div>
                    ):null
                }
           </div>
            <div className="tarhhaDrawerPlace">
                <TarhDarDrawer/>
            </div>

        </div>

    );
}
 
export default TarhDarProducts;